// extracted by css-extract-rspack-plugin
export default {"cls1":"ImpactStatTile-cls1_axv","cls2":"ImpactStatTile-cls2_jaP ImpactStatTile-cls1_axv","loading":"ImpactStatTile-loading_pc_"};